// extracted by mini-css-extract-plugin
export default {"slideButtonsContainer":"qlTrA9rHK6e7TdkaGNPH","slideButton":"zoPInmZwY6VmKF0_LgKu","selected":"rz5VMxIOJ7EnfknHoR7N","hidden":"rcRJXMiSeQI0hufJNSNs"};